import Button from 'apollo-react/components/Button';
import PlusIcon from 'apollo-react-icons/Plus';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

export const CustomHeader = ({ onAddRow }) => {
  const translateString = useTranslation();

  return (
    <div>
      <Button color="secondary" icon={PlusIcon} variant="secondary" onClick={onAddRow}>
        {translateString('Add')}
      </Button>
    </div>
  );
};
